import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

const SaleTransactionCustomerVerification = ({ txn }) => {
  return (
    <div className='verification-required'>
      <Helmet>
        <title>Customer verification: Merchant Demonstrator</title>
      </Helmet>
      {txn && txn.cust_verification_required && txn.cust_verification_required.visit_url && (
        <URLVerification url={txn.cust_verification_required.visit_url} />
      )}
    </div>
  )
}
SaleTransactionCustomerVerification.propTypes = {
  txn: PropTypes.object.isRequired,
}

const HtmlVerification = ({ html }) => (
  <div className='render_html'>
    <p className='explanation'>The upstream PSP requires HTML customer verification, for example 3D-Secure:</p>
    <iframe
      name='merchant-iframe'
      className='verification'
      srcDoc={html}
      allow='camera'
      sandbox={'allow-modals allow-forms allow-scripts allow-same-origin allow-popups'}
    />
  </div>
)
HtmlVerification.propTypes = {
  html: PropTypes.string.isRequired,
}

const URLVerification = ({ url }) => (
  <div className='visit_url'>
    <p className='explanation'>
      Customer verification required at:{' '}
      <a href={url} target='_blank' rel='noreferrer'>
        <code>{url}</code>
      </a>
    </p>
    <iframe
      name='merchant-iframe'
      className='verification'
      src={url}
      allow='camera'
      sandbox={'allow-modals allow-forms allow-scripts allow-same-origin allow-popups'}
    />
  </div>
)
URLVerification.propTypes = {
  url: PropTypes.string.isRequired,
}

export default SaleTransactionCustomerVerification
